// @ts-nocheck
/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import { AvatarGroup } from '@mui/material';

const DEFAULT_MAX = 5;
const DEFAULT_SPACING = 'medium';
const DEFAULT_VARIANT = 'circular';

/**
 * SolyticsAvatarGroup - Wrapper around MUI AvatarGroup
 *
 * @param {React.ReactNode} children - Avatar elements
 * @param {number} max - Max avatars visible before +x overflow
 * @param {number} total - Total avatars count (optional)
 * @param {string|number} spacing - Spacing between avatars
 * @param {string} variant - Avatar shape for grouped avatars
 * @param {object|Array|function} sx - Additional sx overrides
 */
const SolyticsAvatarGroup = React.forwardRef(
  (
    {
      children,
      max = DEFAULT_MAX,
      total,
      spacing = DEFAULT_SPACING,
      variant = DEFAULT_VARIANT,
      id,
      title,
      className,
      sx,
    },
    ref
  ) => {
    return (
      <AvatarGroup
        ref={ref}
        max={max}
        spacing={spacing}
        variant={variant}
        {...(total !== undefined && { total })}
        {...(id !== undefined && { id })}
        {...(title !== undefined && { title })}
        {...(className !== undefined && { className })}
        sx={sx}
      >
        {children}
      </AvatarGroup>
    );
  }
);

SolyticsAvatarGroup.displayName = 'SolyticsAvatarGroup';

export default memo(SolyticsAvatarGroup);
